import { metrics } from '@atlassian/browser-metrics';

export const issueTransitionModalLoad = metrics.interaction({
	key: 'issue-transition-modal',
});

export const issueTransittionModalLoadSubsequent = metrics.interaction({
	key: 'issue-transition-modal-subsequent',
});
